import { createTheme } from '@material-ui/core/styles';

const themeOverrides = {
    overrides: {
        MuiPaper: {
            root: {
                boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.50) !important',
                width: 'auto',
                borderRadius: '10px !important',
            }
        },
        MuiPopover: {
            paper: {
                backgroundColor: 'var(--white-500, #FFF)',
            },
        },
    }
};
export const toobarTheme = createTheme(themeOverrides);